import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import History from 'Store/history';
import { cmsUpdater } from 'Store/actions';
import EnvironmentManager from 'Utils/environmentManager';
const InviteFriendFlag = ({ children })  => {
  const dispatch = useDispatch();
  const cms = useSelector(state => state.cms.updater ?? {});
  const referencePageVisible = EnvironmentManager.getMessageText({ key: 'reference_page_visible' })  === 'true';

  useEffect(() => {
    dispatch(cmsUpdater());
  }, []);

  useEffect(() => {
    if (cms?.data && !referencePageVisible) {
      History.push('/');
    }
  }, [cms?.data, referencePageVisible]);

  if (cms?.data && referencePageVisible) {
    return  <>{ children }</>;
  }

  return null;
  
};

InviteFriendFlag.propTypes = {
  children: PropTypes.element.isRequired,
};

export default InviteFriendFlag;
